export type HeaderFooterMode =
  | 'DEFAULT'
  | 'MINIMAL_HEADER_AND_NO_FOOTER'
  | 'MINIMAL_HEADER'
  | 'NO_FOOTER'

export function getHeaderFooterMode(headerFooterMode: HeaderFooterMode) {
  if (!headerFooterMode || headerFooterMode === 'DEFAULT') {
    return {
      isMinimalHeader: false,
      showFooter: true,
    }
  }

  if (headerFooterMode === 'MINIMAL_HEADER') {
    return {
      isMinimalHeader: true,
      showFooter: true,
    }
  }

  if (headerFooterMode === 'MINIMAL_HEADER_AND_NO_FOOTER') {
    return {
      isMinimalHeader: true,
      showFooter: false,
    }
  }

  if (headerFooterMode === 'NO_FOOTER') {
    return {
      isMinimalHeader: false,
      showFooter: false,
    }
  }
}
